import moment from "moment";
import * as Yup from "yup";
import { TestContext } from "yup";

export const creditCardExpiryValidation = Yup.string().test(
  "future_date",
  "Should be in the future",
  function(this: TestContext, value: string) {
    if (value) {
      const expiryDate = new Date(
        Number(`20${value.slice(2)}`),
        Number(value.slice(0, 2)) - 1,
        1
      );
      return new Date() < expiryDate;
    } else {
      return true;
    }
  }
);

const todayMidnight = new Date();
todayMidnight.setHours(0, 0, 0, 0);

export const dateInFuture = Yup.date().min(
  todayMidnight,
  "Should be in the future"
);

export const number = Yup.number().transform((value: number) =>
  isNaN(value) ? 0 : value
);

export const positiveNumber = number.positive("Should be a positive number");

export const dueDateValidation = (initialValue: Date) =>
  Yup.date().test("dueDate", "Should be in the future", (value: Date) => {
    const initial = moment(initialValue)
      .startOf("day")
      .toDate();

    const current = moment(value)
      .startOf("day")
      .toDate();

    const today = moment()
      .startOf("day")
      .toDate();

    if (initial.getTime() === current.getTime()) {
      return true;
    } else if (current >= today) {
      return true;
    } else {
      return false;
    }
  });

export const nullableNumberValidation = Yup.number()
  .nullable()
  .transform((value: string | number, originalValue: string | number) =>
    originalValue === undefined ||
    isNaN(Number(originalValue)) ||
    String(originalValue) === ""
      ? null
      : Number(value)
  );
